export default __webpack_public_path__ + "static/media/partner-01.4fb7555e.png";